import React from 'react';
import { Main, Container, FadeImage } from './styles/Global.styles';
import { Theme } from './utils/Theme';
import { ThemeProvider } from 'styled-components';
import Presentation from './components/Presentation';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import TopImage from './assets/top.png';
import RightImage from './assets/right.png';

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <Main>
        <Container>
          <Navbar />
          <Presentation />
          <Skills />
          <Projects />
          <Contact />
        </Container>
        <FadeImage src={TopImage} alt="Top" top="0" />
        <FadeImage src={RightImage} alt="Right" top="0" right="0" />
      </Main>
    </ThemeProvider>
  );
}

export default App;
